import { useQuery } from '@tanstack/react-query';

import { useResolvedOwnerId } from '@/hooks/analytics/useResolvedOwnerId';
import { creditService } from '@/services/data/CreditService';

export function useCreditWallet() {
  const { data: ownerId } = useResolvedOwnerId();

  return useQuery({
    queryKey: ['credit-wallet', ownerId],
    enabled: Boolean(ownerId),
    queryFn: () => creditService.getWallet(),
    staleTime: 60_000,
    retry: 1,
    retryDelay: 1000,
  });
}
